import { useMemo } from 'react';

// material-ui
import { alpha, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project import
import HeaderContent from './HeaderContent';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const headerContent = useMemo(() => <HeaderContent />, []);

  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      px: { xs: 1.5, sm: 2.5 },
      pt: { xs: 1, sm: 1.5 },
      background: 'transparent',
      boxShadow: 'none'
    }
  };

  return (
    <AppBar {...appBar}>
      <Toolbar
        sx={{
          minHeight: 76,
          px: { xs: 1.5, sm: 2.5 },
          borderRadius: 4,
          border: '1px solid',
          borderColor: alpha(theme.palette.divider, downLG ? 1 : 0.85),
          backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === 'dark' ? 0.9 : 0.82),
          backdropFilter: 'blur(18px)',
          boxShadow: `0 20px 45px -30px ${alpha(theme.palette.grey[900], theme.palette.mode === 'dark' ? 0.45 : 0.18)}`
        }}
      >
        <Box sx={{ width: '100%' }}>{headerContent}</Box>
      </Toolbar>
    </AppBar>
  );
}
